import { Element } from "@/scripts/extends";

export default class Button extends Element {}
